export default __webpack_public_path__ + "static/Крысиные бега_15-b15924bb388dad9b9792a55632b12b40.jpg";